import axios from '../axios-init'

export const mixedPackageApi = {
    // ==================== 仓库端接口 ====================
    
    // 创建混寄包裹
    createMixedPackage(params) {
        return axios.post('/mixed-package/warehouse/create', params).then(res => res.data).catch(err => err)
    },
    
    // 分页查询混寄包裹列表
    getMixedPackageList(params) {
        return axios.post('/mixed-package/warehouse/list', params).then(res => res.data).catch(err => err)
    },
    
    // 获取混寄包裹详情
    getMixedPackageDetail(mixedPackageId) {
        return axios.get('/mixed-package/warehouse/detail/' + mixedPackageId).then(res => res.data).catch(err => err)
    },
    
    // 取消混寄包裹
    cancelMixedPackage(mixedPackageId) {
        return axios.delete('/mixed-package/warehouse/cancel/' + mixedPackageId).then(res => res.data).catch(err => err)
    },
    
    // 分页查询认领审核列表
    getClaimListForReview(params) {
        console.log('API: getClaimListForReview called with params:', params);
        return axios.post('/mixed-package/warehouse/claims/review', params).then(res => {
            console.log('API: getClaimListForReview success response:', res);
            return res.data;
        }).catch(err => {
            console.log('API: getClaimListForReview error:', err);
            throw err; // 重新抛出错误，让axios拦截器处理
        })
    },
    
    // 批准认领
    approveClaim(claimId) {
        return axios.post('/mixed-package/warehouse/claims/' + claimId + '/approve', {}).then(res => res.data).catch(err => { throw err; })
    },

    // 调整认领数量
    adjustClaimQuantity(claimId, params) {
        return axios.post('/mixed-package/warehouse/claims/' + claimId + '/adjust', params).then(res => res.data).catch(err => { throw err; })
    },

    // 拒绝认领
    rejectClaim(claimId, params) {
        return axios.post('/mixed-package/warehouse/claims/' + claimId + '/reject', params).then(res => res.data).catch(err => { throw err; })
    },

    // 回滚认领记录到待审核状态
    rollbackClaimToPending(claimId) {
        return axios.post('/mixed-package/warehouse/claims/' + claimId + '/rollback', {}).then(res => res.data).catch(err => { throw err; })
    },

    // 批量库存下放
    batchDistribute(params) {
        return axios.post('/mixed-package/warehouse/claims/batch-distribute', params).then(res => res.data).catch(err => { throw err; })
    },

    // 批量库存下放（支持每个claim独立设置收费时间）
    batchDistributeWithIndividualSettings(params) {
        return axios.post('/mixed-package/warehouse/claims/batch-distribute-individual', params).then(res => res.data).catch(err => { throw err; })
    },
    
    // 分页查询未认领商品
    getUnclaimedItems(params) {
        return axios.post('/mixed-package/warehouse/unclaimed-items', params).then(res => res.data).catch(err => err)
    },

    // 导出未认领商品
    exportUnclaimedItems(params) {
        return axios.post('/excel/exportUnclaimedItems', params, {responseType: 'blob'}).then(res => res.data).catch(err => err)
    },

    // 导出待确认批次
    exportPendingBatches(params) {
        return axios.post('/excel/exportPendingBatches', params, {responseType: 'blob'}).then(res => res.data).catch(err => err)
    },
    
    // 统计待审核认领数量
    countPendingClaims() {
        return axios.get('/mixed-package/warehouse/pending-claims-count').then(res => res.data).catch(err => { throw err; })
    },
    
    // ==================== 神医/护士端接口 ====================
    
    // 搜索可认领商品
    searchClaimableItems(params) {
        return axios.post('/mixed-package/claim/search', params).then(res => res.data).catch(err => err)
    },
    
    // 获取可认领仓库列表
    getAccessibleWarehouses(params) {
        return axios.post('/mixed-package/claim/accessible-warehouses', params).then(res => res.data).catch(err => err)
    },
    
    // 提交认领
    submitClaim(params) {
        return axios.post('/mixed-package/claim/submit', params).then(res => res.data).catch(err => err)
    },
    
    // 分页查询我的认领记录
    getMyClaimList(params) {
        return axios.post('/mixed-package/claim/my-claims', params).then(res => res.data).catch(err => err)
    },
    
    // 取消认领
    cancelClaim(claimId) {
        return axios.delete('/mixed-package/claim/' + claimId).then(res => res.data).catch(err => err)
    },
    
    // 获取Inbound待处理认领数量
    getPendingClaimQuantity(inboundNo) {
        return axios.get('/mixed-package/claim/inbound/' + inboundNo + '/pending-quantity').then(res => res.data).catch(err => err)
    },
    
    // ==================== 公共接口 ====================
    
    // 检查快递单号是否存在
    checkTrackingExists(tracking) {
        return axios.get('/mixed-package/check-tracking/' + tracking).then(res => res.data).catch(err => err)
    },
    
    // 设置强制收费时间
    setForceChargeTime(params) {
        return axios.post('/mixed-package/warehouse/claims/set-force-charge-time', params).then(res => res.data).catch(err => { throw err; })
    },

    // 设置强制收费时间（支持每个claim独立设置）
    setForceChargeTimeWithIndividualSettings(params) {
        return axios.post('/mixed-package/warehouse/claims/set-force-charge-time-individual', params).then(res => res.data).catch(err => { throw err; })
    },

    // 批量批准认领
    batchApprove(params) {
        return axios.post('/mixed-package/warehouse/claims/batch-approve', params).then(res => res.data).catch(err => err)
    },

    // 单个包裹撤销
    reverseByPackageId(params) {
        return axios.post('/mixed-package/warehouse/reverse-by-id', params).then(res => res.data).catch(err => err)
    },

    // ==================== 批量操作接口 ====================

    // 生成批次号
    generateBatchNumber() {
        return axios.post('/mixed-package/batch/generateBatchNumber').then(res => res.data).catch(err => err)
    },

    // 批量UPC验证
    validateUPCs(params) {
        return axios.post('/mixed-package/batch/validateUPCs', params).then(res => res.data).catch(err => err)
    },

    // Text格式批量导入
    batchTextImport(params) {
        return axios.post('/mixed-package/batch/textImport', params).then(res => res.data).catch(err => err)
    },

    // Excel格式批量导入
    batchExcelImport(formData) {
        return axios.post('/mixed-package/batch/excelImport', formData).then(res => res.data).catch(err => err)
    },

    // 获取待确认批次列表
    getPendingBatches(params) {
        return axios.post('/mixed-package/batch/pending-batches', params).then(res => res.data).catch(err => err)
    },

    // 获取待确认包裹列表 (按批次号 + Tracking维度)
    getPendingPackages(params) {
        return axios.post('/mixed-package/batch/pending-packages', params).then(res => res.data).catch(err => err)
    },

    // 确认单个包裹
    confirmSinglePackage(params) {
        return axios.post('/mixed-package/batch/confirm-single-package', params).then(res => res.data).catch(err => {
            console.error('confirmSinglePackage API error:', err)
            return Promise.reject(err)
        })
    },

    // 取消单个包裹
    cancelSinglePackage(params) {
        return axios.post('/mixed-package/batch/cancel-single-package', params).then(res => res.data).catch(err => err)
    },

    // 获取包裹详情 (显示UPC维度)
    getPackageDetail(params) {
        return axios.post('/mixed-package/batch/package-detail', params).then(res => res.data).catch(err => err)
    },

    // 从包裹中删除UPC
    deleteUPCFromPackage(params) {
        return axios.post('/mixed-package/batch/delete-upc', params).then(res => res.data).catch(err => err)
    },

    // 编辑包裹中的UPC
    editUPCInPackage(params) {
        return axios.post('/mixed-package/batch/edit-upc', params).then(res => res.data).catch(err => err)
    },

    // 获取批次详情
    getBatchDetail(batchNumber) {
        return axios.get('/mixed-package/batch/batch-detail/' + batchNumber).then(res => res.data).catch(err => err)
    },

    // 批量确认创建混寄包裹
    bulkConfirmBatch(params) {
        return axios.post('/mixed-package/batch/bulkConfirm', params).then(res => res.data).catch(err => err)
    },

    // 获取可撤销批次列表
    getReversibleBatches(params) {
        return axios.post('/mixed-package/batch/reversible-batches', params).then(res => res.data).catch(err => err)
    },

    // 检查批次撤销可行性
    checkBatchReversibility(batchNumber) {
        return axios.get('/mixed-package/batch/check-reversibility/' + batchNumber).then(res => res.data).catch(err => err)
    },

    // 批量撤销混寄包裹
    bulkReverseBatch(params) {
        return axios.post('/mixed-package/batch/bulkReverse', params).then(res => res.data).catch(err => err)
    },

    // 批量取消待确认批次
    cancelPendingBatch(batchNumber) {
        return axios.delete('/mixed-package/batch/cancel/' + batchNumber).then(res => res.data).catch(err => err)
    },

    // 获取批量操作预估时间
    estimateBatchOperationTime(batchNumber, operationType) {
        return axios.get('/mixed-package/batch/estimate-time/' + batchNumber + '?operationType=' + operationType).then(res => res.data).catch(err => err)
    },

    // ==================== 批次批量撤销接口 ====================

    // 获取可撤销的批次号列表
    getBatchNumbers(params) {
        return axios.post('/mixed-package/warehouse/batch-numbers', params).then(res => res.data).catch(err => err)
    },

    // 根据批次号获取包裹列表
    getPackagesByBatchNumber(params) {
        return axios.post('/mixed-package/warehouse/packages-by-batch', params).then(res => res.data).catch(err => err)
    },

    // 批次批量撤销
    batchBulkReverse(params) {
        return axios.post('/mixed-package/warehouse/batch-bulk-reverse', params).then(res => res.data).catch(err => err)
    },

    // 更新混寄包裹UPC数量
    updateMixedPackageUPCQty(params) {
        return axios.post('/mixed-package/warehouse/update-upc-qty', params).then(res => res.data).catch(err => { throw err; })
    }
}


// WEBPACK FOOTER //
// ./src/api/mixedPackage.js